import { ICatalogFilterCheckbox, ICatalogFilterCheckBoxProps } from 'tkmp-lib/src/interfaces';
import { Checkbox } from 'antd';
import { router } from 'next/client';
import { CatalogQueryService } from '@/utils/services/CatalogQueryService';
import React from 'react';

const CatalogCheckboxItem = ({
    checked,
    catalogType,
    item_value,
    category_name,
    item_title,
}: ICatalogFilterCheckBoxProps) => {
    console.log(category_name);
    return (
        <Checkbox
            checked={checked}
            onChange={(_) => {
                const responseVariable: ICatalogFilterCheckbox = {
                    property: category_name,
                    value: item_value.value,
                    isRange: false,
                };

                router.push({
                    pathname: CatalogQueryService.getNewUrl(catalogType, responseVariable),
                });
            }}
        >
            <div>
                <span className="text-16-400">{item_value.value}</span>
            </div>
        </Checkbox>
    );
};

export default CatalogCheckboxItem;
